var exports = {
  "i": "AltTextBadge.module__wrapper___S3ZzdW",
  "x": "AltTextBadge.module__button___S3ZzdW",
};

module.exports = exports;
